import { useEffect } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  FOOTBALL_PLAY_RIVALS_LEAGUES,
  FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_ONBOARDING,
} from '@sorare/core/src/constants/__generated__/routes';
import { isType } from '@sorare/core/src/gql';
import useMutation from '@sorare/core/src/hooks/graphql/useMutation';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { JOIN_LEAGUE_MUTATION } from 'components/rivalsUserGroup/JoinLeagueDialog';

import { PageParams } from './__generated__/routeParams';

const RivalsLeaguesJoinPage = () => {
  const [join, { loading }] = useMutation(JOIN_LEAGUE_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
  const { joinSecret } = useTypedParams<PageParams>();
  const navigate = useNavigate();

  useEffect(() => {
    join({
      variables: {
        input: {
          joinSecret,
        },
      },
    }).then(({ data }) => {
      const userGroup = data?.joinSo5UserGroup?.userGroup;
      if (isType(userGroup, 'RivalsUserGroup') && userGroup.affiliate) {
        navigate(FOOTBALL_PLAY_RIVALS_LEAGUES);
        return;
      }
      navigate(
        generatePath(FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_ONBOARDING, {
          slug: data!.joinSo5UserGroup!.userGroup!.slug,
        })
      );
    });
  }, [join, joinSecret, navigate]);

  return loading && <LoadingIndicator fullScreen />;
};
export default RivalsLeaguesJoinPage;
